<template>
  <div v-if="contents.length > 0" class="live live02">
    <div class="inner">
      <Title>
        <template #title>
          メインチャンネル
        </template>
      </Title>
      <div class="description">
        <p>
          スペシャルゲストとしてよしお兄さんが登場！親子で楽しめる歌やダンスのステージのほか、ツルハドラッグから暮らしのヒントになる情報をお届けします。
        </p>
      </div>
      <div class="live-programs">
        <LiveProgram10tsuruha
          v-for="(program, key) in contents"
          :key="program.id + key + 'provider'"
          :program="program"
          liveType="provider"
          :month="month"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/atoms/Title.vue'
import LiveProgram10tsuruha from '@/components/molecules/202010tsuruha/LiveProgram.vue'

export default {
  props: {
    month: {
      type: String,
      required: true
    },
    contents: {}
  },
  components: {
    Title,
    LiveProgram10tsuruha
  }
}
</script>

<style lang="sass" scoped>
.live02
  padding: 25px 0
</style>